/* eslint-disable import/no-webpack-loader-syntax */
import { useEffect, useState } from "react";

import { Skeleton } from "antd";
import { DotChartOutlined } from "@ant-design/icons";

import { getLocationAddress } from "./api-handler";
import { handleError } from "../../utils/common-utils";

import GoogleMapPlaces from "./google-map-places";

import { getDefaultViewPort, mapCurrentLocation } from "./map-utils";
import HexMapFooter from "./HexMapFooter";
import "./style.css";

const HexMap = ({ mapProps, onClose, onSave, modal, distance, mapError }) => {
  const { latitude, longitude } = mapProps || { latitude: "", longitude: "" };

  const [mapAddress, setMapAddress] = useState(null);
  const [addressText, setAddressText] = useState(mapProps.addressText || "");
  const [viewport, setViewPort] = useState(
    getDefaultViewPort({ latitude, longitude })
  );

  const [mapNotification, setMapNotification] = useState("");

  const [currentLocationAllowed, setCurrentLocationAllowed] = useState(true);

  const [loading, setLoading] = useState(false);
  const [mapLoader, setMapLoader] = useState(!latitude || false);

  const isEditable = Boolean(onSave);

  useEffect(() => {
    setMapNotification(mapError);
  }, [mapError]);

  useEffect(() => {
    if (!latitude && !longitude) {
      mapCurrentLocation({
        onSuccess: ({ allowedLocation, ...rest }) => {
          setCurrentLocationAllowed(allowedLocation);
          getMapInformation(rest);
        },
      });
    } else {
      getMapInformation({ lat: latitude, lng: longitude }, addressText);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveMapAddress = (address) => {
    !modal && onSave(address);
    modal && setMapAddress(address);
  };

  const getMapInformation = ({ lat, lng }, addressInfo) => {
    setLoading(true);
    setViewPort((prev) => ({
      ...prev,
      latitude: lat,
      longitude: lng,
      zoom: 15,
    }));

    getLocationAddress({ lat, long: lng })
      .then(({ data }) => {
        const { address } = data;
        const text = addressInfo || address.address1;

        const addressDetails = {
          latitude: lat,
          longitude: lng,
          ...address,
          address1: text,
        };

        saveMapAddress(addressDetails);

        setAddressText(text);

        setLoading(false);
        setMapLoader(false);

        mapProps.onChangeAddress && mapProps.onChangeAddress(addressDetails);
        !mapError && setMapNotification("");
      })
      .catch((error) => {
        const errorMessage = handleError(error);
        setMapNotification(errorMessage);

        saveMapAddress(null);
        setMapLoader(false);
        setLoading(false);
      });
  };

  const handleMarkerChange = ({ lngLat, addressText }) => {
    getMapInformation(lngLat, addressText);
  };

  const handleGeoLocate = ({ coords }) => {
    const { latitude, longitude } = coords;
    getMapInformation({ lat: latitude, lng: longitude });
  };

  const handleSave = () => {
    onSave(mapAddress);
  };

  if (mapLoader)
    return (
      <Skeleton.Node active={true} className="p-1 full-width map-skeleton">
        <DotChartOutlined style={{ fontSize: 40, color: "#bfbfbf" }} />
      </Skeleton.Node>
    );

  return (
    <div>
      <div className={`hex-map ${!isEditable ? "viewable-map" : ""}`}>
        <GoogleMapPlaces
          initialViewPort={viewport}
          onMarkerChange={handleMarkerChange}
          onLocate={handleGeoLocate}
          editable={isEditable}
          currentLocationAllowed={currentLocationAllowed}
          addressText={addressText}
          distance={distance}
        />
      </div>

      <HexMapFooter
        modal={modal}
        loading={loading}
        onClose={onClose}
        editable={isEditable}
        handleSave={handleSave}
        mapNotification={mapNotification}
      />
    </div>
  );
};

export default HexMap;
